import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { DataMultiDisplayCard } from '../cards/DataMultiDisplayCard';

/**
 * Fetch risk profile information and render it using a data card.
 */
export const RiskProfile = () => {
    const { t } = usePrefixTranslation(['dashboard', 'common'], { dashboard: 'metrics.RiskProfile' });
    const dispatch = useTypedDispatch();
    const { riskProfile } = useTypedSelector(state => ({ riskProfile: state.stats.riskProfile }));
    const counts = Object.entries(riskProfile.stats ?? {}).filter(
        ([name]) => name !== 'not-defined' && name !== 'moderate-low',
    );
    const total = counts.reduce((acc, next) => acc + next[1], 0);
    const colors = { low: ['#FFF'], moderate: ['#FE9'], 'moderate-high': ['#F76'], high: ['#A13'] };
    const data = counts.map(([name, count]) => {
        const ratio = count / total;
        return {
            name: t(`common:probability.${name}`),
            value: count,
            color: (colors as any)[name],
            main: t('percent', { count: ratio * 100 }),
            info: t('equipment', { count }),
            ratio,
        };
    });

    React.useEffect(() => void dispatch(actions.stats.riskProfile()), []);

    return <DataMultiDisplayCard fetching={riskProfile.fetching} name={t('title')} data={data} mode='tile' />;
};
